import { User } from "@supernova-studio/model";
import { z } from "zod";

export const DTOUserProfileUpdateResponse = z.object({
  user: User,
});

export type DTOUserProfileUpdateResponse = z.infer<typeof DTOUserProfileUpdateResponse>;
